export default __webpack_public_path__ + "static/media/Profile.39602742.svg";